import "./style.css";
import { TaskList } from "./task";

function App() {
  return (
    <main>
      <h1>Task Manager</h1>
      <TaskList />
    </main>
  );
}

export default App;
